import { Route } from 'react-router-dom-v5-compat'
import * as api from '~/api'
import { ContactInterests } from '~/views/Onboarding/pages/ContactInterests'
import {
  ServiceProviderCompanyConfirmForm,
  ServiceProviderCompanyForm,
} from '../forms/ServiceProviderCompanyForm'
import { CompanyDetails } from '../pages/CompanyDetails'
import { ContactEducation } from '../pages/ContactEducation'
import { ContactIdentification } from '../pages/ContactIdentification'
import { ContactLocation } from '../pages/ContactLocation'
import { ContactSocialMedia } from '../pages/ContactSocialMedia'
import {
  Step,
  getNextStep,
  makeGetNextPagePath,
  makeGetPreviousPagePath,
} from './utils'

const contactSteps = [Step.ContactIdentification, Step.ContactLocation]

const steps = [Step.CompanyDetails, ...contactSteps]

const wizardSteps = [
  { path: Step.ContactIdentification, title: 'Contact Info' },
  { path: Step.ContactLocation, title: 'Location' },
  // { path: Step.ContactEducation, title: 'Education' },
  // { path: Step.ContactInterest, title: 'Interests' },
  // { path: Step.ContactSocialMedia, title: 'Social Media' },
]

export const serviceProviderWorkflow = {
  getStartingPagePath: ({ company }) => {
    return company.hasCompanyOnboarded
      ? getNextStep(contactSteps, null, null)
      : Step.CompanyDetails
  },
  getNextPagePath: makeGetNextPagePath(steps),
  getPreviousPagePath: makeGetPreviousPagePath(steps),

  routes: [
    <Route
      key={Step.CompanyDetails}
      path={Step.CompanyDetails}
      element={
        <CompanyDetails
          getSavedAnswers={api.onboarding.getServiceProviderCompanyAnswers}
          saveAnswers={api.onboarding.saveServiceProviderCompanyAnswers}
          editForm={<ServiceProviderCompanyForm />}
          confirmForm={<ServiceProviderCompanyConfirmForm />}
        />
      }
    />,
    <Route
      key={Step.ContactIdentification}
      path={Step.ContactIdentification}
      element={<ContactIdentification steps={wizardSteps} />}
    />,
    <Route
      key={Step.ContactLocation}
      path={Step.ContactLocation}
      element={<ContactLocation steps={wizardSteps} />}
    />,
  ],
}
